import { createIcon } from './createIcon';

/**
 * Checkmark. Marks the selected row in a menu and confirms a copy — the three
 * hand-rolled variants that preceded it all rendered at 12px and differed
 * only in stroke geometry, so they are one glyph now.
 */
export const CheckIcon = createIcon({
  name: 'CheckIcon',
  viewBox: '0 0 12 12',
  size: 12,
  children: (
    <path
      d="M2.5 6.5 5 9l4.5-6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});

export default CheckIcon;
